const InvoiceLayout = ({ children }) => {
  return (
    <div className="card mb-0 shadow-none responsive-card">
      <div className="card-body d-flex p-2" id="element-to-download">
        <div
          className="pt-2"
          style={{
            overflowY: "auto",
            width: "100%",
            maxHeight: "100%",
            paddingRight: "8px",
            paddingLeft: "8px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default InvoiceLayout;